<template>
  <div>
    <a-form layout="horizontal">
      <!-- 核查因子 & 量程 -->
      <a-row :gutter="24">
        <a-col :md="12" :sm="24">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="核查因子">
            <a-select v-model="formData.factorCode" placeholder="请选择核查因子" :disabled="disableSubmit" @change="onFactorChange">
              <a-select-option v-for="f in factorOptions" :key="f.code" :value="f.code">
                {{ f.name }}（{{ f.unit }}）
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :md="12" :sm="24">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="量程最高值">
            <a-input-number v-model="formData.rangeMax" :disabled="disableSubmit" style="width: 80%" />
            <span style="margin-left: 5px">{{ formData.factorUnit || '' }}</span>
          </a-form-item>
        </a-col>
      </a-row>

      <!-- 多点数据表格 -->
      <a-row>
        <a-col :span="24">
          <qc-point-table
            ref="pointTable"
            :pointConfig="st21PointConfig"
            :initPoints="initPoints"
            :disableSubmit="disableSubmit"
            :unit="formData.factorUnit"
            :rangeMax="formData.rangeMax"
            errorMode="st21"
            @point-change="onPointChange"
          />
        </a-col>
      </a-row>

      <!-- 相关系数 & 合格 -->
      <a-row :gutter="24" style="margin-top: 15px">
        <a-col :md="12" :sm="24">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="相关系数">
            <span>{{ formData.correlationCoefficient != null ? formData.correlationCoefficient : '--' }}</span>
          </a-form-item>
        </a-col>
        <a-col :md="12" :sm="24">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="是否合格">
            <a-select v-model="formData.qualified" :disabled="disableSubmit" placeholder="请选择">
              <a-select-option value="yes">合格</a-select-option>
              <a-select-option value="no">不合格</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
      </a-row>

      <!-- 备注 -->
      <a-row>
        <a-col :md="24">
          <a-form-item :labelCol="{ span: 4 }" :wrapperCol="{ span: 20 }" label="备注">
            <a-textarea v-model="formData.remark" :disabled="disableSubmit" placeholder="请输入备注" />
          </a-form-item>
        </a-col>
      </a-row>

      <!-- 附件 -->
      <a-row style="margin-top: 5px">
        <a-col>

          <iws-upload ref="itemUpload" :options="{ btnText: '上传附件' }" :disableSubmit="disableSubmit"
            filesrc="om_qc_st21_item" :srcid="formData.id" />
        </a-col>
      </a-row>
    </a-form>
  </div>
</template>

<script>
import { getAction } from '@/api/manage'
import IwsUpload from '@comp/upload/IwsUpload.vue'
import QcPointTable from './QcPointTable'

export default {
  name: 'St21MonthMultipointForm',
  components: { QcPointTable, IwsUpload },
  props: {
    disableSubmit: { type: Boolean, default: false },
    siteId: { type: [Number, String], default: null },
    st: { type: String, default: '21' },
    maintenanceType: { type: String, default: '' },
    qcMeasure: { type: String, default: '' },
    pagePath: { type: String, default: '/om/qc/ledger' },
    dataItems: { type: Array, default: () => [] },
  },
  data() {
    return {
      formData: {
        id: null,
        qcMeasure: 'multipoint_linear',
        factorCode: undefined,
        factorName: '',
        factorUnit: '',
        rangeMax: null,
        correlationCoefficient: null,
        qualified: undefined,
        remark: '',
      },
      factorOptions: [],
      initPoints: [],
      labelCol: { span: 8 },
      wrapperCol: { span: 16 },
      /** ST21多点：零点、低点、中点、高点 */
      st21PointConfig: [
        { pointName: 'zero', pointSort: 1 },
        { pointName: 'low', pointSort: 2 },
        { pointName: 'mid', pointSort: 3 },
        { pointName: 'high', pointSort: 4 },
      ],
    }
  },
  watch: {
    dataItems: {
      immediate: true,
      handler(val) {
        if (val && val.length > 0) {
          let item = val[0]
          this.formData = { ...this.formData, ...item }
          this.initPoints = item.points || []
        }
      },
    },
  },
  created() {
    this.loadFactorWhitelist()
  },
  methods: {
    loadFactorWhitelist() {
      if (!this.siteId) return
      Promise.all([
        getAction(this.pagePath + '/factorWhitelist', { st: '21', qcMeasure: 'multipoint_linear' }),
        getAction('/site/info/factor/find/' + this.siteId)
      ]).then(([resWhite, resSite]) => {
        if (resWhite.success && resWhite.result) {
          let siteFactors = (resSite.success && resSite.result) ? resSite.result : []
          let options = []
          resWhite.result.forEach((code) => {
            let f = siteFactors.find((sf) => sf.code === code)
            if (f) options.push({ code: code, name: f.title, unit: f.unitName || '' })
          })
          this.factorOptions = options
        }
      })
    },
    onFactorChange(code) {
      let f = this.factorOptions.find((i) => i.code === code)
      if (f) {
        this.formData.factorCode = f.code
        this.formData.factorName = f.name
        this.formData.factorUnit = f.unit
      }
    },
    /** 多点数据变化时重新计算相关系数 */
    onPointChange(points) {
      let x = [], y = []
      points.forEach((p) => {
        if (p.standardValue != null && p.measuredValue != null) {
          x.push(p.standardValue)
          y.push(p.measuredValue)
        }
      })
      if (x.length >= 2) {
        this.formData.correlationCoefficient = this.calcCorrel(x, y)
      } else {
        this.formData.correlationCoefficient = null
      }
    },
    /** Pearson相关系数 */
    calcCorrel(x, y) {
      let n = x.length
      let sumX = 0, sumY = 0, sumXY = 0, sumX2 = 0, sumY2 = 0
      for (let i = 0; i < n; i++) {
        sumX += x[i]; sumY += y[i]
        sumXY += x[i] * y[i]
        sumX2 += x[i] * x[i]; sumY2 += y[i] * y[i]
      }
      let denom = Math.sqrt((n * sumX2 - sumX * sumX) * (n * sumY2 - sumY * sumY))
      if (denom === 0) return null
      let r = (n * sumXY - sumX * sumY) / denom
      return Math.floor(r * 10000) / 10000 // 保留4位
    },
    /** 收集数据 */
    collectData() {
      if (!this.formData.factorCode) {
        this.$message.warning('请选择核查因子')
        return null
      }
      let points = this.$refs.pointTable.getPointsData()
      // 收集附件数据（非必填）
      if (this.$refs.itemUpload) {
        let fd = this.$refs.itemUpload.getUploadList ? this.$refs.itemUpload.getUploadList() : {}
        this.formData.sysFileList = fd.sysFileList || []
        this.formData.fileDelList = fd.fileDelList || []
      }
      return [{ ...this.formData, points }]
    },
  },
}
</script>
